import * as ng from 'angular';
import uiRouter from '@uirouter/angularjs';
import { ScaricaArchivioComponent } from './scarica-archivio';

// @ngInject
let stateConfig = ($stateProvider: ng.ui.IStateProvider) => {

    $stateProvider
        .state('unsubscription.scarica-archivio', {
            url: '/scarica-archivio',
            //                        ncyBreadcrumb: {
            //                            label: 'Scarica Archivio',
            //                            parent: 'unsubscription.unsubscription-index'
            //                        },
            data: {
                authorisationLevel: 1,
                pageTitle: 'Scarica Archivio'
            },
            'views': {
                'multiContentUnsubscription': {
                    template: '<scarica-archivio flex="100"></scarica-archivio>'
                }
            }
        });
};

stateConfig.$inject = ['$stateProvider'];

export const ScaricaArchivioModule: string = ng
    .module('scarica-archivio', [
        'ui.bootstrap',
        uiRouter
    ])
    .component('scaricaArchivio', ScaricaArchivioComponent)
    .config(stateConfig)
    .name;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/sections/unsubscription/scarica-archivio/scarica-archivio.module.ts